import { Link, Outlet } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { isDashboardRole } from '../../services/userService';

const PRIMARY_LINKS = [
  { href: '/about', label: 'About' },
  { href: '/articles', label: 'Articles' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/course-content', label: 'Course Content' },
];

const FOOTER_LINKS = [
  { href: '/partner_page', label: "Partner's Page" },
  { href: '/dw_donations', label: 'Donations' },
  { href: '/dw_terms_conditions', label: 'Terms and Conditions' },
  { href: '/privacy_policy', label: 'Privacy Policy' },
  {
    href: '/dw_course_terms_and_conditions',
    label: 'Workshop Terms and Conditions',
  },
];

function SiteNavLink({ href, label, external = false, onNavigate }) {
  if (external) {
    return (
      <a
        className="navbar__item--link"
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        onClick={onNavigate}
      >
        |{label}
      </a>
    );
  }

  return (
    <Link className="navbar__item--link" to={href} onClick={onNavigate}>
      |{label}
    </Link>
  );
}

export default function PublicLayout() {
  const { user, profile, signOut } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const canAccessDashboard = isDashboardRole(profile?.role);

  async function handleSignOut() {
    try {
      setIsSigningOut(true);
      await signOut();
    } finally {
      setIsSigningOut(false);
    }
  }

  return (
    <div>
      <div className="navbar__wrap">
        <nav className="navbar navbar-default navbar-static-top" id="DWTop-Nav">
          <Link className="navbar-left navbar__item--logo" to="/">
            <img
              className="navbar__item--logo-image"
              src="/static/site_pictures/disinfo_badge_scaled_cropped.png"
              alt="Disinformation Warriors logo"
            />
          </Link>

          <button
            className="navbar-toggle"
            data-toggle="collapse"
            data-target=".navbar__collapsable--menu"
            style={{ marginTop: '3.5rem' }}
            type="button"
            onClick={() => setMenuOpen((current) => !current)}
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>

          <div
            className={`collapse navbar-collapse navbar__collapsable--menu${
              menuOpen ? ' in' : ''
            }`}
          >
            <ul
              className="nav navbar-nav navbar__list"
              id="nav-link-list"
              style={{ float: 'right' }}
            >
              {PRIMARY_LINKS.map((link) => (
                <li key={link.label}>
                  <SiteNavLink
                    href={link.href}
                    label={link.label}
                    external={link.external}
                    onNavigate={() => setMenuOpen(false)}
                  />
                </li>
              ))}

              {user ? (
                <>
                  {canAccessDashboard ? (
                    <li>
                      <Link
                        className="navbar__item--link"
                        to="/dashboard"
                        onClick={() => setMenuOpen(false)}
                      >
                        |Dashboard
                      </Link>
                    </li>
                  ) : null}
                  <li>
                    <button
                      type="button"
                      className="navbar-link-button navbar__item--link"
                      onClick={handleSignOut}
                      disabled={isSigningOut}
                    >
                      |{isSigningOut ? 'Signing out...' : 'Sign out'}
                    </button>
                  </li>
                </>
              ) : null}
            </ul>
          </div>
        </nav>
      </div>

      {user ? (
        <div className="container site-user-chip">
          Signed in as {profile?.displayName || user.email || user.uid} (
          {profile?.role || 'viewer'})
        </div>
      ) : null}

      <main className="container site-content">
        <Outlet />
      </main>

      <footer id="DWBottom-Nav">
        <div className="container">
          <div className="footer__wrap">
            <ul className="nav navbar-nav text-center" id="nav-link-list">
              {FOOTER_LINKS.map((link) => (
                <li key={link.label}>
                  <Link className="footer__item--link" to={link.href}>
                    |{link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  className="footer__item--caos"
                  href="http://animatedobjects.ca/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  |Presented by CAOS
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
